// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"History_modalBody__2ZaFW"};